define('editor/edit/contexts/settings',['durandal/app', 'jquery', 'knockout'], function (app, $, ko) {
    var viewmodel = function () {
        var self = this;

        self.settingsForm = ko.observable();

        self.activate = function (editorMap) {
            self.editorMapId = editorMap.id;

            self.show();
        };

        self.show = function () {
            self.settingsForm({ model: 'editor/metadata/metadata', activationData: [self.onSave, self.onSaveError, self.editorMapId] });
        };

        self.save = function (model, event) {
            var button = $(event.currentTarget),
               theForm = button.closest('[data-view]').find('form'),
               submitButton = theForm.find('[type=submit]');

            submitButton.click(); // makes sure validation happens
        };

        self.onSave = function (newData) {
            var newSettings = {
                title: newData.title,
                height: newData.height,
                width: newData.width,
                useLabelsLayer: newData.useLabelsLayer
            };
            
            self.editorMap = newData;
            
            app.trigger('map:settings:updated', newSettings);
            app.showMessage("Changes Saved", "Changes Saved", ["Close"]);
           
        };

        self.onSaveError = function (error) {
            app.showMessage("Unable to save map metadata: " + error, "Save Metadata Failed");
        };
    };

    return viewmodel;
});
